import { render, staticRenderFns } from "./SubscribeSection.vue?vue&type=template&id=483192aa&scoped=true"
import script from "./SubscribeSection.vue?vue&type=script&lang=js"
export * from "./SubscribeSection.vue?vue&type=script&lang=js"
import style0 from "./SubscribeSection.vue?vue&type=style&index=0&id=483192aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483192aa",
  null
  
)

export default component.exports